import { Logout } from '@mui/icons-material'
import { Button, Drawer, List, ListItem } from '@mui/material'
import clsx from 'clsx'
import { NavLink } from 'react-router-dom'
import { PageContainer } from '..'
import { APP_LINKS } from '../../database/app-link'
import { useAuth, useSidebar } from '../../hooks'

export default function MobileMenu() {
  const { user, logout } = useAuth()
  const { open, toggle } = useSidebar()

  if (!user) return null

  return (
    <Drawer open={open} onClose={toggle} anchor="right">
      <PageContainer className="bg-background2 py-8 h-full flex flex-col">
        <List className="flex-1">
          {APP_LINKS.map(({ icon, label, link, roles }) => {
            if (!roles.includes(user.accessLevel)) return null
            else
              return (
                <ListItem
                  onClick={toggle}
                  className="w-full text-sm"
                  key={label}
                >
                  <NavLink
                    to={link}
                    className={({ isActive }: { isActive: boolean }) =>
                      clsx(
                        isActive
                          ? 'bg-backgroundHover text-primary'
                          : 'hover:bg-backgroundHover text-white',
                        'w-full gap-2 py-3 px-6 rounded-xl no-underline flex items-center',
                      )
                    }
                  >
                    {icon}

                    {label}
                  </NavLink>
                </ListItem>
              )
          })}
        </List>

        <Button
          onClick={logout}
          variant="outlined"
          className="!w-full !gap-4 !justify-start"
          fullWidth
        >
          <Logout />
          <span>Logout</span>
        </Button>
      </PageContainer>
    </Drawer>
  )
}
